<feature-toggle-provider [features]="configService.getSelfServiceConfig()">
    <div class="container-fluid py-5 bg-white">
        <div class="container">
            <div class="row">
                <div class="col-12 p-5 col-md-8 order-1 order-sm-0">
                    <p *featureToggle="'enableDashboardRoleDisplay'">{{ role }}</p>
                    <h1>
                        <!-- Welcome, firstName lastName -->
                        {{
                            'SELF_SERVICE.DASHBOARD.OVERVIEW.TITLE'
                                | translate : { firstName: firstName, lastName: lastName }
                        }}
                    </h1>
                    <p class="my-4">
                        <!-- Here you can manage your personal data and settings to optimally adapt your Viessmann account to your needs. -->
                        {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.DESCRIPTION' | translate }}
                    </p>
                </div>
                <div class="col-12 p-0 p-md-5 col-md-4 d-flex justify-content-center order-0 order-sm-1">
                    <div class="avatar-container" (click)="openAvatarDialog()">
                        <img
                            [src]="avatar ? avatar : '../../../../../assets/img/self-service/avatar.svg'"
                            alt=""
                            class="avatar"
                        />
                        <div class="lower-right">
                            <button mat-mini-fab class="bg-white">
                                <mat-icon>edit</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container-fluid py-5 bg-grey-light">
        <div class="container">
            <div class="row">
                <!-- Personal data -->
                <div class="col-12 col-md-6 col-lg-4 mb-4">
                    <a routerLink="/personal-data">
                        <mat-card class="card p-5 h-100">
                            <div class="">
                                <h2>
                                    <!-- Personal data -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.PERSONAL_DATA_CARD.TITLE' | translate }}
                                </h2>
                                <img src="../../../../../assets/img/self-service/profile.svg" alt="" class="my-4" />
                                <p>
                                    <!-- Here you can view and change your personal data for your Viessmann account. This includes your name, e-mail address or password. -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.PERSONAL_DATA_CARD.DESCRIPTION' | translate }}
                                </p>
                            </div>
                        </mat-card>
                    </a>
                </div>
                <!-- Company data -->
                <div class="col-12 col-md-6 col-lg-4 mb-4" *featureToggle="'enableCompanyData'">
                    <a routerLink="company-data">
                        <mat-card class="card p-5 h-100">
                            <div>
                                <h2>
                                    <!-- Company data -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.COMPANY_DATA_CARD.TITLE' | translate }}
                                </h2>
                                <img src="../../../../../assets/img/self-service/company.svg" alt="" class="my-4" />
                                <p>
                                    <!-- You can enter and adjust basic settings and data for your company in the master data. -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.COMPANY_DATA_CARD.DESCRIPTION' | translate }}
                                </p>
                            </div>
                        </mat-card>
                    </a>
                </div>
                <!-- Notifications -->
                <div class="col-12 col-md-6 col-lg-4 mb-4" *featureToggle="'enableNotifications'">
                    <a routerLink="/notifications">
                        <mat-card class="card p-5 h-100">
                            <div>
                                <h2>
                                    <!-- Notifications -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.NOTIFICATIONS_CARD.TITLE' | translate }}
                                </h2>
                                <img
                                    src="../../../../../assets/img/self-service/notifications.svg"
                                    alt=""
                                    class="my-4"
                                />
                                <p>
                                    <!-- In this section you can manage all notifications in one place. -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.NOTIFICATIONS_CARD.DESCRIPTION' | translate }}
                                </p>
                            </div>
                        </mat-card>
                    </a>
                </div>
                <!-- Employees -->
                <div class="col-12 col-md-6 col-lg-4 mb-4" *featureToggle="'enableEmployees'">
                    <a routerLink="employees">
                        <mat-card class="card p-5 h-100">
                            <div>
                                <h2>
                                    <!-- Employees -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.EMPLOYEES_CARD.TITLE' | translate }}
                                </h2>
                                <img src="../../../../../assets/img/self-service/contacts.svg" alt="" class="my-4" />
                                <p>
                                    <!-- Here you can add new employees and update existing ones. Assign additional roles and rights. -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.EMPLOYEES_CARD.DESCRIPTION' | translate }}
                                </p>
                            </div>
                        </mat-card>
                    </a>
                </div>
                <!-- Roles & Permissions -->
                <div class="col-12 col-md-6 col-lg-4 mb-4" *featureToggle="'enableRolesAndPermissions'">
                    <a routerLink="roles-and-permissions">
                        <mat-card class="card p-5 h-100">
                            <div>
                                <h2>
                                    <!-- Roles and permissions -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.ROLES_CARD.TITLE' | translate }}
                                </h2>
                                <img
                                    src="../../../../../assets/img/self-service/roles_and_permissions.svg"
                                    alt=""
                                    class="my-4"
                                />
                                <p>
                                    <!-- Here you can view and change all roles and authorisations for Viessmann applications in one place. -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.ROLES_CARD.DESCRIPTION' | translate }}
                                </p>
                            </div>
                        </mat-card>
                    </a>
                </div>
                <!-- Best Practices -->
                <div class="col-12 col-md-6 col-lg-4 mb-4" *featureToggle="'enableBestPractices'">
                    <a [href]="supportUrl" target="_blank" rel="noopener">
                        <mat-card class="card p-5 h-100">
                            <div>
                                <h2>
                                    <!-- Best Practices -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.BEST_PRACTICES_CARD.TITLE' | translate }}
                                </h2>
                                <img src="../../../../../assets/img/self-service/tips.svg" alt="" class="my-4" />
                                <p>
                                    <!-- Here you can find best practices about the application. -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.BEST_PRACTICES_CARD.DESCRIPTION' | translate }}
                                </p>
                            </div>
                        </mat-card>
                    </a>
                </div>
                <!-- Purchases and Subscriptions -->
                <div class="col-12 col-md-6 col-lg-4 mb-4" *featureToggle="'enablePurchasesAndSubscriptions'">
                    <a routerLink="/purchases">
                        <mat-card class="card p-5 h-100">
                            <div>
                                <h2>
                                    <!-- Purchases and subscriptions -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.PURCHASES_AN_SUBSCRIPTIONS.TITLE' | translate }}
                                </h2>
                                <img src="../../../../../assets/img/self-service/purchase.svg" alt="" class="my-4" />
                                <p>
                                    {{
                                        'SELF_SERVICE.DASHBOARD.OVERVIEW.PURCHASES_AN_SUBSCRIPTIONS.DESCRIPTION'
                                            | translate
                                    }}
                                </p>
                            </div>
                        </mat-card>
                    </a>
                </div>
                <!-- Settings -->
                <div class="col-12 col-md-6 col-lg-4 mb-4" *featureToggle="'enableSettings'">
                    <a routerLink="/settings">
                        <mat-card class="card p-5 h-100">
                            <div>
                                <h2>
                                    <!-- Settings -->
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.SETTINGS.TITLE' | translate }}
                                </h2>
                                <img src="../../../../../assets/img/self-service/settings.svg" alt="" class="my-4" />
                                <p>
                                    {{ 'SELF_SERVICE.DASHBOARD.OVERVIEW.SETTINGS.DESCRIPTION' | translate }}
                                </p>
                            </div>
                        </mat-card>
                    </a>
                </div>
            </div>
        </div>
    </div>
</feature-toggle-provider>
